<template >
    <v-app >
    <leftmenu />
    
    <v-main class="secondary" >
      <router-view>
        
      </router-view>
    </v-main>
  </v-app>
</template>

<script>
import leftmenu from '@/components/leftmenu'


export default {
  name: 'App',
  components:{ leftmenu },
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
tbody{
  tr:hover{
    background-color: #B0BEC5 !important;
  }
}
</style>
